module.exports = __webpack_public_path__ + "img/amex-icon.f60b68f0.svg";